<template>
  <div class="d-flex flex-column flex-grow-1">
    <filtered-data
      ref="data"
      v-model="data"
      endpoint="modems/deleted"
      :filtersValue="filtersValue"
      :loading.sync="loading"
      :hasMore.sync="hasMore"
      :sort="sort"
    ></filtered-data>


    <template v-if="data && data.data">
      <data-table-full-height
        :data="modems"
        @sort-change="sortChange"
        @load-more="loadMore"
        :hasMore="hasMore"
        :loading="loading"
      >
        <el-table-column prop="uid" label="№ модема" sortable="custom" width="200">
          <template slot-scope="{row}">
            <div>{{ row.number }}</div>
            <div><small>{{ row.uid }}</small></div>
          </template>
        </el-table-column>
        <table-column-date prop="last_command_at" label="Последняя команда" sortable="custom" width="auto"/>
        <el-table-column align="center" label="Восстановить" width="180">
          <template slot-scope="{row}">
            <btn-action class="btn btn-sm btn-outline-light" @click.stop="() => restoreModem(row.uid)">Восстановить</btn-action>
          </template>
        </el-table-column>
      </data-table-full-height>
    </template>
  </div>
</template>

<script>
  import api from '@/api'
  import EditModal from '../../../components/modems/edit-modal.vue'

  export default {
    metaInfo: {title: 'Удаленные модемы'},
    data () {
      return {
        filtersValue: {},
        data: {},
        loading: false,
        hasMore: true,
        sort: {prop: 'uid', order: 'asc'},
        updateList: 0,
      }
    },
    watch: {
    },
    computed: {
      modems () {
        return this.data.data
      },
    },
    methods: {
      restoreModem (uid) {
        return api.put(`/modems/${uid}/restore`)
          .then(() => this.$router.push('/modems'))
      },
      loadMore () {
        this.$refs.data.loadMore()
      },
      sortChange (sort) {
        if (sort.prop) {
          const order = sort.order === 'ascending' ? 'asc' : 'desc'
          this.sort = {
            prop: sort.prop,
            order,
          }
        } else {
          this.sort = null
        }
      },
    },
  }
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// resources/assets/js/pages/modems/index/deleted.vue